import {TransferType} from '@sollapay/enums';

import {MasavTransferBadge} from './MasavTransferBadge';
import {ZahavTransferBadge} from './ZahavTransferBadge';

import type {PaymentInstructionDTO} from '@sollapay/types';
import type {FC} from 'react';

export interface TransferTypeCellProps {
  transferType: PaymentInstructionDTO['transferType'];
}

/** Instructions created before the transfer type was recorded went out as a regular transfer. */
export const TransferTypeCell: FC<TransferTypeCellProps> = ({transferType}) =>
  transferType === TransferType.ZAHAV ? <ZahavTransferBadge /> : <MasavTransferBadge />;
